import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  align-self: center;
  height: 100vh;
  align-items: center;
`;
